<ng-container [formGroup]="selectFormGroup">
  <ng-select class='custom' [closeOnSelect]='true' [clearable]='true' [clearSearchOnAdd]='true' appearance='outline' appendTo="body"
            formControlName='{{data.options.key}}' [searchable]='data.options.is_api' (search)='search($event.term)' placeholder='{{data.place_holder}}'>
    <ng-option *ngFor='let item of list' [value]='item[data.options.display_item_value]'>{{item[data.options.display_item_name]}}</ng-option>
  </ng-select>
</ng-container>
